





















































































































































import BaseCmsBlock from '../../node_modules/sitis-nuxt/lib/cms/CmsBlockMixin'

export default BaseCmsBlock.extend({
  name: "SocialBlock",

  computed: {
    title: function () {
      return this?.values?.title || "Подпишитесь на наши соц. сети"
    },
    telegramLinkLinzaruBot: function () {
      return this.$store?.state?.appState?.vars?.["telegram_link_linzaru_bot"] || "#"
    },
  },
});
